import React, { useState, useEffect, useCallback } from 'react';
import { useData } from '../contexts/DataContext';
import api from '../lib/api';
import LabelsTab from '../components/wms/LabelsTab';

const WMSLabelsPage = () => {
  const { plants } = useData();
  const [bins, setBins] = useState([]);

  const fetchBins = useCallback(async () => {
    try {
      const response = await api.get('/bins');
      setBins(response.data);
    } catch (error) {
      console.error('Error:', error);
    }
  }, []);

  useEffect(() => {
    fetchBins();
  }, [fetchBins]);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-slate-900">Etichete si Rapoarte - WMS</h1>
        <p className="text-slate-600 mt-1">Generare etichete BIN si rapoarte stoc</p>
      </div>
      <LabelsTab plants={plants} bins={bins} />
    </div>
  );
};

export default WMSLabelsPage;